/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FileType;
(function (FileType) {
    FileType["Unknown"] = "Unknown";
    FileType["LeasingAgreement"] = "LeasingAgreement";
    FileType["InsurancePolicy"] = "InsurancePolicy";
    FileType["CustomerAgreement"] = "CustomerAgreement";
    FileType["CarModel"] = "CarModel";
    FileType["CarPhoto"] = "CarPhoto";
    FileType["DamageVisualisationPhoto"] = "DamageVisualisationPhoto";
    FileType["DamageModel"] = "DamageModel";
    FileType["Protocol"] = "Protocol";
    FileType["ProtocolSignature"] = "ProtocolSignature";
    FileType["TechnicalReview"] = "TechnicalReview";
    FileType["DamageVisualisationVideo"] = "DamageVisualisationVideo";
    FileType["CarAttachment"] = "CarAttachment";
    FileType["GarageMainPhoto"] = "GarageMainPhoto";
    FileType["CarHistoryReport"] = "CarHistoryReport";
    FileType["ServiceActionAttachment"] = "ServiceActionAttachment";
})(FileType || (FileType = {}));
export function FileTypeFromJSON(json) {
    return FileTypeFromJSONTyped(json, false);
}
export function FileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FileTypeToJSON(value) {
    return value;
}
